import React from "react";
import { motion } from "framer-motion";
import { HardHat, Wrench, Building, Briefcase, ArrowUpRight } from "lucide-react";
import { useI18n } from "../context/I18nContext";

const ICONS = [HardHat, Wrench, Building, Briefcase];

const Services = () => {
  const { t } = useI18n();
  const items = t("services.items");

  return (
    <section
      id="services"
      className="bg-mayak-bg text-mayak-text py-24 lg:py-36 mayak-grain relative overflow-hidden"
      data-testid="services-section"
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-4">
            <span className="mayak-eyebrow">{t("services.eyebrow")}</span>
            <h2 className="mt-6 font-black text-4xl sm:text-5xl lg:text-6xl tracking-[-0.03em] leading-[1.02] text-mayak-text">
              {t("services.title")}
            </h2>
          </div>
          <div className="lg:col-span-7 lg:col-start-6 flex items-end">
            <p className="text-mayak-dim text-base lg:text-lg max-w-xl leading-relaxed">
              {t("services.subtitle")}
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6">
          {Array.isArray(items) &&
            items.map((s, i) => {
              const Icon = ICONS[i] || HardHat;
              return (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.1 }}
                  transition={{ delay: i * 0.08, duration: 0.7 }}
                  className="service-card mayak-flip-card"
                  data-testid={`service-card-${i}`}
                >
                  <div className="mayak-flip-inner">
                    <div className="mayak-flip-face service-face">
                      <div className="flex justify-between items-start">
                        <Icon className="text-mayak-accent" size={32} strokeWidth={1.5} />
                        <span className="font-mono text-xs text-mayak-faint">
                          0{i + 1}
                        </span>
                      </div>
                      <div>
                        <h3 className="font-black text-2xl lg:text-3xl text-mayak-text tracking-tight mb-3">
                          {s.title}
                        </h3>
                        <p className="text-sm text-mayak-dim leading-relaxed">
                          {s.short}
                        </p>
                        <div className="mt-6 flex items-center gap-2 text-[10px] uppercase tracking-[0.3em] text-mayak-accent">
                          <span>{t("services.learnMore")}</span>
                          <ArrowUpRight size={12} />
                        </div>
                      </div>
                    </div>
                    <div className="mayak-flip-face mayak-flip-back service-face service-face-back">
                      <Icon className="text-mayak-accent-bright" size={28} strokeWidth={1.5} />
                      <div>
                        <h3 className="font-black text-xl text-mayak-accent tracking-tight mb-4">
                          {s.title}
                        </h3>
                        <p className="text-sm text-mayak-text leading-relaxed">
                          {s.long}
                        </p>
                      </div>
                      <div className="text-[10px] uppercase tracking-[0.3em] text-mayak-accent">
                        Mayak — 0{i + 1}
                      </div>
                    </div>
                  </div>
                </motion.div>
              );
            })}
        </div>
      </div>
    </section>
  );
};

export default Services;
